import SVG from "react-inlinesvg"
import { UbLucideIconStoryblok } from "@/components/storyblok/component-types"

//Workaround for eliminating icon problems
export default function LucideIcon({ blok }: {blok: UbLucideIconStoryblok}) {
  return (
    <>
      {blok?.icon ? (
        <SVG
          src={"/img/icons/lucide/" + blok.icon.toLowerCase() + ".svg"}
          width={128}
          className={"size-6"}
          height="auto"
          title={blok?.icon}
        />
      ) : (
        // eslint-disable-next-line @next/next/no-img-element
        <img className={"size-6"} src={"/img/icons/lucide/squircle.svg"} alt={""} />
      )}
    </>
  )
}
